import { useCallback, useEffect, useState } from "react"
import { formatDuration } from "../utils/date.ts"

export const useTimer = (start = 0, intervalMs = 1000) => {
	const [duration, setDuration] = useState(start)
	const [isRunning, setIsRunning] = useState(false)

	useEffect(() => {
		let timer: ReturnType<typeof setInterval> | null = null

		if (isRunning) {
			timer = setInterval(() => {
				setDuration((prev) => prev + 1)
			}, intervalMs)
		}

		return () => {
			if (timer) {
				clearInterval(timer)
			}
		}
	}, [intervalMs, isRunning])

	const startTimer = useCallback(() => setIsRunning(true), [])
	const stopTimer = useCallback(() => setIsRunning(false), [])
	const resetTimer = useCallback(() => {
		setIsRunning(false)
		setDuration(start)
	}, [start])

	return {
		duration,
		isRunning,
		startTimer,
		stopTimer,
		resetTimer,
		formattedDuration: formatDuration(duration),
	}
}
